import React from "react";
import RepalceCards from "../RepalceItems/RepalceCards";

export default function AddSpotlight() {
  return <RepalceCards />;
}
